import { render, staticRenderFns } from "./getAllRoutes.vue?vue&type=template&id=601e5cee&scoped=true"
import script from "./getAllRoutes.vue?vue&type=script&lang=js"
export * from "./getAllRoutes.vue?vue&type=script&lang=js"
import style0 from "./getAllRoutes.vue?vue&type=style&index=0&id=601e5cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e5cee",
  null
  
)

export default component.exports